import React from 'react';
import Modal from 'shared/components/misc/modal.jsx';
import UIRegions from 'shared/constants/UIRegions';
import { Grid, Row, Col, Input, Button, Alert } from 'bootstrap';
import CuesheetCellActions from 'shared/flux/actions/cuesheet/CuesheetCellActions';
import ModalActions from 'flux/actions/ModalActions';
import { getFileExtension } from 'shared/lib/file';
import { validImageTypes } from 'flux/stores/cuesheet/CuesheetConstants';

/**
 * Add Asset To Cell
 */
export default React.createClass({
  displayName: 'CellAssetModal',

  getInitialState: function () {
    return {
      exceededMaxFileSize: false,
      invalidFileExtension: false,
    };
  },

  render() {
    let supportedImageString = '';

    let numberValidImages = validImageTypes.length;

    supportedImageString = validImageTypes.map((t, i) => {
      if (i < numberValidImages - 1) {
        return t.concat(', ');
      }
      return ' & '.concat(t);
    });

    let photoRequirementsNode = (
      <span>2mb max. We support {supportedImageString} file types.</span>
    );

    return (
      <Modal
        className="cs-cell-asset-modal"
        onHide={this._handleOnHide}
        name={UIRegions.CellAsset}
        title={'Insert photo'}
        closeButton
      >
        <Grid fluid>
          <Row>
            <Col>
              <div className="cs-asset-modal-description">
                <p>
                  Photos are publicly accessible, so keep this in mind if you're
                  uploading confidential or private photos.
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={24}>
              <Input ref="title" type="text" label="Image Title:" />
            </Col>
            <Col md={24}>
              <Input ref="url" type="text" label="Insert image by URL:" />
            </Col>
            <Col md={24}>
              <p>or</p>
            </Col>
            <Col md={24}>
              <Input
                ref="file"
                type="file"
                label="Upload from File"
                onChange={this._handlePhotoSelect}
              />
              <div>
                {this._invalidFileExtensionErrorNode(supportedImageString)}
              </div>
              <div>{this._exceededFileSizeErrorNode()}</div>
              <div className="profile-image-guide-text">
                {photoRequirementsNode}
              </div>
            </Col>
            <Col md={24}>
              <Button
                className="btn-insert-photo"
                data-testid="confirm-insert-image"
                onClick={this._handleInsertClick}
              >
                Insert Photo
              </Button>
            </Col>
          </Row>
        </Grid>
      </Modal>
    );
  },

  _handlePhotoSelect(e) {
    this.setState({
      exceededMaxFileSize: false,
      invalidFileExtension: false,
    });

    let file = e.target.files[0];

    if (file && this._exceededFileSize(file))
      return this.setState({ exceededMaxFileSize: true });
    if (file && this._invalidFileType(file))
      return this.setState({ invalidFileExtension: true });
  },

  _handleInsertClick() {
    let title = this.refs.title.getValue();
    let url = this.refs.url.getValue();
    let file = this.refs.file.getInputDOMNode().files[0];

    if (file && (this._exceededFileSize(file) || this._invalidFileType(file)))
      return;

    if (url) {
      CuesheetCellActions.saveSelectedCellTextWithImage(title, url);
    } else if (file) {
      CuesheetCellActions.addCellAsset(title, file);
    }

    if (!this.state.error) ModalActions.hide(UIRegions.CellAsset);
  },

  _handleOnHide() {
    this.setState({
      exceededMaxFileSize: false,
      invalidFileExtension: false,
    });
    ModalActions.hide(UIRegions.CellAsset);
  },

  _invalidFileType(file) {
    let fileName = file.name;
    let fileExtension = getFileExtension(fileName);

    let invalidExtension = true;

    validImageTypes.forEach((fileType) => {
      if ('.' + fileType === fileExtension) {
        invalidExtension = false;
      }
    });

    return invalidExtension;
  },

  _invalidFileExtensionErrorNode(supportedImages) {
    if (!this.state.invalidFileExtension) return null;

    return (
      <Alert bsStyle="danger">
        <p>Only {supportedImages} image types can be inserted into a cell.</p>
      </Alert>
    );
  },

  _exceededFileSize(file) {
    let maxFileSize = 2097152;

    return file.size > maxFileSize;
  },

  _exceededFileSizeErrorNode() {
    if (!this.state.exceededMaxFileSize) return null;

    return (
      <Alert bsStyle="danger">
        <p>
          That image's file size is too big. Images must be under 2mb in size!
        </p>
      </Alert>
    );
  },
});
